import React from 'react';
import { FaHeart, FaTimes } from 'react-icons/fa';

const Favorites = ({ favorites, onSelectMovie, onToggleFavorite }) => {
  if (!favorites.length) return null;

  return (
    <div className="favorites-section">
      <div className="section-header">
        <div className="section-title">
          <FaHeart className="icon" style={{ color: 'var(--accent-red)' }} />
          My Collection
        </div>
        <span className="section-badge">{favorites.length} saved</span>
      </div>

      <div className="favorites-scroll">
        {favorites.map((movie) => {
          const posterUrl = movie.Poster !== 'N/A'
            ? movie.Poster
            : 'https://via.placeholder.com/300x450/1a1a3e/6a6a8e?text=No+Poster';

          return (
            <div
              key={movie.imdbID}
              className="fav-card"
              onClick={() => onSelectMovie(movie.imdbID)}
            >
              <div className="fav-poster">
                <img src={posterUrl} alt={movie.Title} loading="lazy" />
                <button
                  className="fav-remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggleFavorite(movie);
                  }}
                  aria-label="Remove from favorites"
                >
                  <FaTimes />
                </button>
              </div>
              <div className="fav-title" title={movie.Title}>{movie.Title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Favorites;
